package se.mittpass.web.pages

import se.mittpass.web.*
import se.mittpass.web.components.*
import se.mittpass.web.pages.*
import se.mittpass.web.viewmodel.*
import se.mittpass.web.style.*


import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.attributes.*
import se.mittpass.shared.api.WorkplaceDto
import se.mittpass.shared.repository.ClaimsRepository
import se.mittpass.shared.repository.SlotsRepository
import se.mittpass.shared.repository.WorkplacesRepository
import se.mittpass.shared.repository.AttendanceRepository
import se.mittpass.shared.repository.PayrollRepository
import se.mittpass.shared.repository.StaffRepository
import se.mittpass.shared.repository.AbsenceRepository
import se.mittpass.shared.repository.AnalyticsRepository
import se.mittpass.shared.repository.ShiftSwapRepository
import se.mittpass.shared.repository.FortnoxRepository
import se.mittpass.shared.repository.MessageRepository
import se.mittpass.shared.repository.CollectiveAgreementRepository
import se.mittpass.shared.repository.ComplianceRepository
import se.mittpass.shared.repository.TimeBankRepository
import se.mittpass.shared.repository.ContractorRepository
import se.mittpass.shared.repository.GeoRepository
import se.mittpass.shared.repository.MultiWorkplaceRepository
import se.mittpass.shared.repository.TipRepository
import se.mittpass.shared.repository.ProjectRepository
import se.mittpass.shared.repository.ExpenseRepository
import se.mittpass.shared.repository.ApiKeyRepository
import se.mittpass.shared.repository.HrRepository
import se.mittpass.shared.repository.InvoiceRepository
import se.mittpass.shared.repository.ScheduleOptRepository
import se.mittpass.shared.api.FeedbackRequest
import se.mittpass.shared.repository.AdminRepository
import se.mittpass.shared.repository.FeedbackRepository
import se.mittpass.shared.repository.FoodSafetyRepository
import se.mittpass.shared.repository.CustomRoleRepository
import se.mittpass.shared.repository.RequirementRepository
import se.mittpass.shared.api.BillingStatusResponse
import io.ktor.client.call.body
import io.ktor.client.request.get

private val dashboardScope = MainScope()
internal val workplacesRepo = WorkplacesRepository(httpClient)
internal val slotsRepo = SlotsRepository(httpClient)
private val claimsRepo = ClaimsRepository(httpClient)
internal val attendanceRepo = AttendanceRepository(httpClient)
internal val payrollRepo = PayrollRepository(httpClient)
internal val staffRepo = StaffRepository(httpClient)
internal val absenceRepo = AbsenceRepository(httpClient)
internal val analyticsRepo = AnalyticsRepository(httpClient)
internal val shiftSwapRepo = ShiftSwapRepository(httpClient)
internal val fortnoxRepo = FortnoxRepository(httpClient)
internal val messageRepo = MessageRepository(httpClient)
internal val collectiveAgreementRepo = CollectiveAgreementRepository(httpClient)
internal val complianceRepo = ComplianceRepository(httpClient)
internal val timeBankRepo = TimeBankRepository(httpClient)
internal val contractorRepo = ContractorRepository(httpClient)
internal val geoRepo = GeoRepository(httpClient)
internal val multiWorkplaceRepo = MultiWorkplaceRepository(httpClient)
internal val tipRepo = TipRepository(httpClient)
internal val projectRepo = ProjectRepository(httpClient)
internal val expenseRepo = ExpenseRepository(httpClient)
internal val apiKeyRepo = ApiKeyRepository(httpClient)
internal val hrRepo = HrRepository(httpClient)
internal val invoiceRepo = InvoiceRepository(httpClient)
internal val scheduleOptRepo = ScheduleOptRepository(httpClient)
internal val foodSafetyRepo = FoodSafetyRepository(httpClient)
internal val adminRepo = AdminRepository(httpClient)
private val feedbackWidgetRepo = FeedbackRepository(httpClient)
internal val customRoleRepo = CustomRoleRepository(httpClient)
internal val requirementRepo = RequirementRepository(httpClient)

private enum class Tab(
    val label: String,
    val icon: String,
    val managerOnly: Boolean = false,
    val slug: String = "",
    val aliases: List<String> = emptyList()
) {
    SCHEMA("Schema", "fa-solid fa-calendar-days", false, "schema"),
    SCHEMA_BUILDER("Skapa schema", "fa-solid fa-wand-magic-sparkles", true, "schema-builder", listOf("skapa-schema")),
    SCHEMA_OPT("Schemaoptimering", "fa-solid fa-robot", true, "schemaoptimering", listOf("schema-opt")),
    PERSONAL("Personal", "fa-solid fa-users", true, "personal"),
    ENTREPRENORER("Entrepren\u00F6rer", "fa-solid fa-building", true, "entreprenorer"),
    HR("HR & Onboarding", "fa-solid fa-folder-open", true, "hr", listOf("onboarding")),
    LIGGARE("Personalliggare", "fa-solid fa-clipboard-list", true, "liggare", listOf("personalliggare")),
    LONER("L\u00F6ner", "fa-solid fa-money-bill-wave", true, "loner"),
    LONEBESKED("Mina l\u00F6nebesked", "fa-solid fa-file-invoice-dollar", false, "lonebesked", listOf("mina-lonebesked")),
    GPS("GPS-inst\u00E4llningar", "fa-solid fa-location-dot", true, "gps"),
    FRANVARO("Fr\u00E5nvaro", "fa-solid fa-calendar-xmark", false, "franvaro"),
    EXPORT("L\u00F6neexport", "fa-solid fa-file-export", true, "export", listOf("fortnox", "fortnox-export", "loneexport")),
    DRICKS("Dricks", "fa-solid fa-coins", true, "dricks"),
    UTLAGG("Utl\u00E4gg", "fa-solid fa-receipt", false, "utlagg"),
    FAKTUROR("Fakturor", "fa-solid fa-file-invoice", true, "fakturor"),
    MEDDELANDEN("Meddelanden", "fa-solid fa-comments", false, "meddelanden"),
    KOLLEKTIVAVTAL("Kollektivavtal", "fa-solid fa-scale-balanced", true, "kollektivavtal"),
    COMPLIANCE("Compliance", "fa-solid fa-shield-halved", true, "compliance"),
    ANALYS("Analys & Rapporter", "fa-solid fa-chart-line", true, "analys", listOf("rapporter")),
    OVERSIKT("\u00D6versikt", "fa-solid fa-globe", true, "oversikt"),
    API_WEBHOOK("API & Webhooks", "fa-solid fa-link", true, "api-webhooks", listOf("api", "webhooks")),
    FAKTURERING("Prenumeration", "fa-solid fa-credit-card", true, "fakturering", listOf("prenumeration", "billing")),
    EGENKONTROLL("Egenkontroll", "fa-solid fa-flask", false, "egenkontroll"),
    INSPEKTION("Inspektionsrapport", "fa-solid fa-clipboard-check", true, "inspektion", listOf("inspektionsrapport")),
    MINA_PASS("Mina pass", "fa-solid fa-house", false, "mina-pass", listOf("pass")),
    PROFIL("Mitt konto", "fa-solid fa-circle-user", false, "profil", listOf("konto", "mitt-konto")),
    SEMESTER("Semester", "fa-solid fa-umbrella-beach", false, "semester"),
    ADMIN("Admin", "fa-solid fa-shield-halved", true, "admin");

    val route: String get() = if (slug.isEmpty()) "/app" else "/app/$slug"

    companion object {
        fun fromPath(path: String): Tab? {
            val segment = path.removePrefix("/app").trim('/').substringBefore('?').substringBefore('/').lowercase()
            if (segment.isEmpty()) return OVERSIKT
            return entries.firstOrNull { it.slug == segment || it.aliases.contains(segment) }
        }
    }
}

private enum class NavSection(val label: String, val icon: String) {
    DAGENS("Idag", "fa-solid fa-mug-saucer"),
    SCHEMA("Schema", "fa-solid fa-calendar-days"),
    PERSONAL("Personal", "fa-solid fa-users"),
    EKONOMI("Ekonomi", "fa-solid fa-money-bill-wave"),
    EGENKONTROLL("Egenkontroll", "fa-solid fa-clipboard-check"),
    INSTÄLLNINGAR("Inställningar", "fa-solid fa-gear")
}

private val NAV_SECTIONS = listOf(
    NavSection.DAGENS to listOf(Tab.OVERSIKT),
    NavSection.SCHEMA to listOf(Tab.SCHEMA, Tab.SEMESTER, Tab.SCHEMA_BUILDER),
    NavSection.PERSONAL to listOf(Tab.PERSONAL, Tab.LIGGARE, Tab.FRANVARO, Tab.MEDDELANDEN),
    NavSection.EKONOMI to listOf(Tab.LONER, Tab.LONEBESKED, Tab.ANALYS, Tab.EXPORT, Tab.COMPLIANCE),
    NavSection.EGENKONTROLL to listOf(Tab.EGENKONTROLL, Tab.INSPEKTION),
    NavSection.INSTÄLLNINGAR to listOf(Tab.FAKTURERING, Tab.KOLLEKTIVAVTAL, Tab.GPS, Tab.ADMIN)
)

private val DAY_NAMES = listOf("M\u00E5n", "Tis", "Ons", "Tor", "Fre", "L\u00F6r", "S\u00F6n")
private const val HOUR_START = 8
private const val HOUR_END = 18

@Composable
fun Dashboard(userInfo: UserInfo?, onLogout: () -> Unit) {
    val isManager = userInfo?.role == "manager"
    val currentUserId = userInfo?.userId
    var isAdmin by remember { mutableStateOf(false) }

    fun isTabAllowed(tab: Tab, blocked: Boolean): Boolean {
        if (!blocked) return true
        return tab == Tab.MINA_PASS || tab == Tab.LONEBESKED || tab == Tab.FAKTURERING || tab == Tab.PROFIL
    }

    val defaultTab = Tab.OVERSIKT
    val initialTab = remember {
        try {
            kotlinx.browser.window.asDynamic().history.scrollRestoration = "manual"
        } catch (_: Exception) {}
        val path = kotlinx.browser.window.location.pathname
        val search = kotlinx.browser.window.location.search
        val tabFromPath = Tab.fromPath(path)
        val tabFromQuery = Regex("[?&]tab=([^&]+)").find(search)?.groupValues?.get(1)?.let { Tab.fromPath(it) }
        val requested = tabFromPath ?: tabFromQuery
        if (requested != null && (!requested.managerOnly || isManager)) {
            requested
        } else {
            defaultTab
        }
    }

    var currentTab by remember { mutableStateOf(initialTab) }
    var workplaces by remember { mutableStateOf<List<WorkplaceDto>>(emptyList()) }
    var selectedWorkplace by remember { mutableStateOf<Long?>(null) }
    var error by remember { mutableStateOf<String?>(null) }
    var loading by remember { mutableStateOf(true) }
    var billingBlocked by remember { mutableStateOf(false) }
    var createAbsenceTrigger by remember { mutableStateOf(0) }

    // Sync tab to browser URL and document title
    LaunchedEffect(currentTab) {
        val expected = currentTab.route
        val currentPath = kotlinx.browser.window.location.pathname.trimEnd('/')
        if (currentPath != expected) {
            if (currentPath == "/app" || currentPath.isEmpty()) {
                kotlinx.browser.window.history.replaceState(null, "", expected)
            } else {
                kotlinx.browser.window.history.pushState(null, "", expected)
            }
        }
        kotlinx.browser.document.title = "${currentTab.label} – Mittpass"
    }

    // Listen to browser Back/Forward (popstate)
    DisposableEffect(isManager, billingBlocked) {
        val handler: (org.w3c.dom.events.Event) -> Unit = {
            val path = kotlinx.browser.window.location.pathname
            if (path.startsWith("/app")) {
                val tabFromPath = Tab.fromPath(path)
                val target = if (tabFromPath != null && (!tabFromPath.managerOnly || isManager) && isTabAllowed(tabFromPath, billingBlocked)) {
                    tabFromPath
                } else {
                    defaultTab
                }
                if (currentTab != target) {
                    currentTab = target
                }
            }
        }
        kotlinx.browser.window.addEventListener("popstate", handler)
        onDispose { kotlinx.browser.window.removeEventListener("popstate", handler) }
    }

    LaunchedEffect(currentTab, selectedWorkplace) {
        try {
            val url = if (selectedWorkplace != null) "billing/status?workplaceId=$selectedWorkplace" else "billing/status"
            val status: BillingStatusResponse = httpClient.get(url).body()
            val days = status.daysLeftInTrial
            billingBlocked = when {
                status.planStatus == "trial" && (days == null || days < 0) -> true
                status.planStatus == "past_due" -> true
                status.planStatus == "canceled" -> true
                else -> false
            }
        } catch (_: Exception) {}
    }

    LaunchedEffect(billingBlocked) {
        if (billingBlocked && !isTabAllowed(currentTab, billingBlocked)) {
            currentTab = if (isManager) Tab.FAKTURERING else Tab.MINA_PASS
        }
    }

    DisposableEffect(Unit) {
        val prev = onBillingBlocked
        onBillingBlocked = { msg ->
            billingBlocked = true
            error = msg
        }
        onDispose {
            onBillingBlocked = prev
        }
    }

    // Responsive breakpoint: < 1024px uses mobile/tablet drawer + compact header
    val windowWidth = rememberWindowWidth()
    val isMobile = windowWidth < 1024
    var sidebarOpen by remember { mutableStateOf(false) }
    var sidebarCollapsed by remember { mutableStateOf(false) }

    suspend fun loadWorkplaces() {
        workplacesRepo.getWorkplaces().fold(
            onSuccess = { list ->
                workplaces = list
                if (selectedWorkplace == null) selectedWorkplace = list.firstOrNull()?.id
            },
            onFailure = { e ->
                val msg = e.message ?: ""
                if (!msg.contains("401") && !msg.contains("Unauthorized", ignoreCase = true)) {
                    error = "Kunde inte hämta arbetsplatser."
                }
            }
        )
    }

    LaunchedEffect(Unit) {
        loadWorkplaces()
        loading = false
        isAdmin = adminRepo.getOverview().isSuccess
    }

    val selectedWorkplaceObj = workplaces.firstOrNull { it.id == selectedWorkplace }
    val userDisplayName = userInfo?.email?.substringBefore("@")?.replace(".", " ")?.replace("-", " ")?.split(" ")?.joinToString(" ") { it.replaceFirstChar { c -> c.uppercase() } } ?: "Anställd"
    val userInitials = userDisplayName.split(" ").mapNotNull { it.take(1).ifEmpty { null } }.joinToString("").take(2).uppercase().ifEmpty { "MP" }
    val userAvatar = userInfo?.userId?.let { uid -> kotlinx.browser.localStorage.getItem("mittpass_avatar_$uid") }

    Div({
        style {
            property("height", "100vh")
            property("display", "flex")
            property("flex-direction", "column")
            property("overflow", "hidden")
            property("font-family", "'Plus Jakarta Sans', system-ui, sans-serif")
            property("background", "var(--rp-base)")
            property("color", "var(--rp-text)")
        }
    }) {
        // ── Top Header Bar ──
        Div({
            classes("no-print", "dashboard-top-header")
            style {
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "space-between")
                property("gap", if (windowWidth >= 1200) "0.75rem" else "0.4rem")
                property("padding", when {
                    windowWidth < 640 -> "0.5rem 0.65rem"
                    windowWidth < 1200 -> "0.55rem 1rem"
                    else -> "0.6rem 1.5rem"
                })
                property("width", "100%")
                property("box-sizing", "border-box")
                property("background", "var(--rp-surface)")
                property("border-bottom", "1px solid var(--rp-hl-med)")
                property("flex-shrink", "0")
                property("z-index", "40")
            }
        }) {
            // Left: Logo + Mobile Hamburger + Workplace Picker
            Div({
                classes("dashboard-header-left")
                style {
                    property("display", "flex")
                    property("align-items", "center")
                    property("gap", if (isMobile) "0.45rem" else "0.35rem")
                    property("min-width", "0")
                    property("flex-shrink", "1")
                }
            }) {
                if (isMobile) {
                    Button({
                        attr("type", "button")
                        onClick { sidebarOpen = !sidebarOpen }
                        attr("aria-label", if (sidebarOpen) "Stäng meny" else "Öppna meny")
                        style {
                            property("background", "var(--rp-overlay)")
                            property("border", "1px solid var(--rp-hl-med)")
                            property("color", "var(--rp-pine)")
                            property("font-size", "1.05rem")
                            property("cursor", "pointer")
                            property("width", "36px")
                            property("height", "36px")
                            property("border-radius", "10px")
                            property("display", "flex")
                            property("align-items", "center")
                            property("justify-content", "center")
                            property("flex-shrink", "0")
                        }
                    }) { FaIcon(if (sidebarOpen) "fa-solid fa-xmark" else "fa-solid fa-bars") }
                }
                Div({
                    style {
                        property("display", "flex")
                        property("align-items", "center")
                        property("gap", "0.45rem")
                        property("flex-shrink", "0")
                        property("cursor", "pointer")
                    }
                    onClick { currentTab = defaultTab }
                }) {
                    Img(src = "/mittpass_logo.svg", alt = "Mittpass") {
                        style {
                            property("width", if (isMobile) "28px" else "30px")
                            property("height", if (isMobile) "28px" else "30px")
                            property("display", "block")
                            property("flex-shrink", "0")
                        }
                    }
                    if (windowWidth >= 380) {
                        Span({
                            classes("dashboard-brand-text")
                            style {
                                property("font-size", if (isMobile) "1rem" else "1.05rem")
                                property("font-weight", "800")
                                property("color", "var(--rp-text)")
                                property("letter-spacing", "-0.3px")
                                property("white-space", "nowrap")
                            }
                        }) { Text("Mittpass") }
                    }
                }

                // Breadcrumbs: Workplace > Tab (rendered on desktop >= 1024px)
                DashboardBreadcrumbs(
                    workplaces = workplaces,
                    selectedWorkplaceId = selectedWorkplace,
                    onSelectWorkplace = { selectedWorkplace = it },
                    currentTabLabel = currentTab.label,
                    onTabClick = { /* already on current tab */ },
                    contextLabel = if (currentTab == Tab.SCHEMA) "v. ${weekNumber(todayLocalDate())}" else null,
                    isMobile = isMobile
                )
            }

            // Center / Nav for Desktop: Manager Navigation (>= 1024px)
            if (!isMobile && isManager) {
                val isCompactNav = windowWidth < 1360
                val isTightDesktop = windowWidth < 1200
                Div({
                    classes("dashboard-top-nav-manager", "no-scrollbar")
                    style {
                        property("display", "flex")
                        property("align-items", "center")
                        property("gap", if (isTightDesktop) "0.12rem" else "0.2rem")
                        property("padding", "0.2rem")
                        property("background", "var(--rp-overlay)")
                        property("border", "1px solid var(--rp-hl-med)")
                        property("border-radius", "9999px")
                        property("min-width", "0")
                        property("flex-shrink", "1")
                        property("overflow-x", "auto")
                        property("max-width", "100%")
                    }
                }) {
                    NAV_SECTIONS.forEach { (section, tabs) ->
                        val isSectionActive = tabs.contains(currentTab)
                        Button({
                            attr("type", "button")
                            attr("data-testid", "section-${section.name}")
                            tabs.firstOrNull()?.let { firstTab ->
                                attr("data-testid", "tab-${firstTab.name}")
                            }
                            onClick {
                                val firstAllowed = tabs.firstOrNull { isTabAllowed(it, billingBlocked) }
                                if (firstAllowed != null) currentTab = firstAllowed
                            }
                            style {
                                property("background", if (isSectionActive) "var(--rp-pine)" else "transparent")
                                property("color", if (isSectionActive) "var(--rp-surface)" else "var(--rp-text)")
                                property("border", if (isSectionActive) "1px solid var(--rp-pine)" else "1px solid transparent")
                                property("border-radius", "9999px")
                                property("padding", when {
                                    isTightDesktop -> "0.32rem 0.52rem"
                                    isCompactNav -> "0.35rem 0.62rem"
                                    else -> "0.4rem 0.85rem"
                                })
                                property("font-size", when {
                                    isTightDesktop -> "0.75rem"
                                    isCompactNav -> "0.78rem"
                                    else -> "0.84rem"
                                })
                                property("font-weight", if (isSectionActive) "700" else "600")
                                property("cursor", "pointer")
                                property("display", "flex")
                                property("align-items", "center")
                                property("gap", if (isCompactNav) "0.3rem" else "0.4rem")
                                property("white-space", "nowrap")
                                property("flex-shrink", "0")
                                property("transition", "all 0.15s ease")
                                if (isSectionActive) property("box-shadow", "var(--rp-shadow-sm)")
                            }
                        }) {
                            if (!isTightDesktop) {
                                FaIcon(section.icon, size = if (isCompactNav) "0.75rem" else "0.8rem", color = if (isSectionActive) "var(--rp-surface)" else "var(--rp-subtle)")
                            }
                            Text(section.label)
                        }
                    }
                }
            }

            // Center / Nav for Desktop: Staff tabs (>= 1024px)
            if (!isMobile && !isManager) {
                val isCompactNav = windowWidth < 1400
                val staffTabs = listOf(Tab.OVERSIKT, Tab.MINA_PASS, Tab.LONEBESKED, Tab.SCHEMA, Tab.SEMESTER, Tab.EGENKONTROLL, Tab.MEDDELANDEN)
                Div({
                    classes("dashboard-top-nav-staff", "no-scrollbar")
                    style {
                        property("display", "flex")
                        property("align-items", "center")
                        property("gap", "0.2rem")
                        property("padding", "0.22rem")
                        property("background", "var(--rp-overlay)")
                        property("border", "1px solid var(--rp-hl-med)")
                        property("border-radius", "9999px")
                        property("min-width", "0")
                        property("flex-shrink", "1")
                        property("overflow-x", "auto")
                        property("max-width", "100%")
                    }
                }) {
                    staffTabs.forEach { tab ->
                        val isActive = currentTab == tab
                        val allowed = isTabAllowed(tab, billingBlocked)
                        Button({
                            attr("type", "button")
                            attr("data-testid", "tab-${tab.name}")
                            if (allowed) onClick { currentTab = tab }
                            style {
                                property("background", if (isActive) "var(--rp-pine)" else "transparent")
                                property("color", if (isActive) "var(--rp-surface)" else "var(--rp-text)")
                                property("border", if (isActive) "1px solid var(--rp-pine)" else "1px solid transparent")
                                property("border-radius", "9999px")
                                property("padding", if (isCompactNav) "0.34rem 0.55rem" else "0.4rem 0.8rem")
                                property("font-size", if (isCompactNav) "0.76rem" else "0.82rem")
                                property("font-weight", if (isActive) "700" else "600")
                                property("cursor", if (allowed) "pointer" else "not-allowed")
                                property("display", "flex")
                                property("align-items", "center")
                                property("gap", if (isCompactNav) "0.28rem" else "0.4rem")
                                property("white-space", "nowrap")
                                property("flex-shrink", "0")
                                property("transition", "all 0.15s ease")
                                if (isActive) property("box-shadow", "var(--rp-shadow-sm)")
                                if (!allowed) property("opacity", "0.4")
                            }
                        }) {
                            FaIcon(tab.icon, size = if (isCompactNav) "0.74rem" else "0.8rem", color = if (isActive) "var(--rp-surface)" else "var(--rp-subtle)")
                            Text(if (tab == Tab.OVERSIKT) "Dagens läge" else tab.label)
                        }
                    }
                }
            }

            // Right: Theme switcher, User Profile & Always-Visible Logout
            val showUserName = (windowWidth in 700..1023) || windowWidth >= 1380
            val showUserBadge = (windowWidth in 820..1023) || windowWidth >= 1520
            Div({
                classes("dashboard-header-right")
                style {
                    property("display", "flex")
                    property("align-items", "center")
                    property("gap", if (windowWidth < 640) "0.35rem" else "0.45rem")
                    property("flex-shrink", "0")
                }
            }) {
                ThemeSwitcher(isCompact = windowWidth < 1680)

                Button({
                    attr("type", "button")
                    onClick { currentTab = Tab.PROFIL }
                    attr("title", "Min profil ($userDisplayName)")
                    style {
                        property("background", if (currentTab == Tab.PROFIL) "var(--rp-overlay)" else "var(--rp-surface)")
                        property("border", if (currentTab == Tab.PROFIL) "1.5px solid var(--rp-pine)" else "1px solid var(--rp-hl-med)")
                        property("border-radius", "9999px")
                        property("padding", if (showUserName) "0.28rem 0.65rem 0.28rem 0.32rem" else "0.25rem")
                        property("display", "flex")
                        property("align-items", "center")
                        property("gap", "0.4rem")
                        property("cursor", "pointer")
                        property("color", "var(--rp-text)")
                        property("flex-shrink", "0")
                    }
                }) {
                    Div({
                        style {
                            property("width", "26px")
                            property("height", "26px")
                            property("border-radius", "50%")
                            if (!userAvatar.isNullOrBlank()) property("background-image", "url('$userAvatar')")
                            if (!userAvatar.isNullOrBlank()) property("background-size", "cover")
                            if (!userAvatar.isNullOrBlank()) property("background-position", "center")
                            if (userAvatar.isNullOrBlank()) property("background", "linear-gradient(135deg, var(--rp-pine), var(--rp-foam))")
                            property("color", "#FFFFFF")
                            property("font-weight", "800")
                            property("font-size", "0.72rem")
                            property("display", "flex")
                            property("align-items", "center")
                            property("justify-content", "center")
                            property("flex-shrink", "0")
                        }
                    }) { if (userAvatar.isNullOrBlank()) Text(userInitials) }
                    if (showUserName) {
                        Span({
                            classes("dashboard-user-name")
                            style {
                                property("font-size", "0.8rem")
                                property("font-weight", "700")
                                property("color", "var(--rp-text)")
                                property("max-width", "105px")
                                property("overflow", "hidden")
                                property("text-overflow", "ellipsis")
                                property("white-space", "nowrap")
                            }
                        }) { Text(userDisplayName) }
                    }
                    if (showUserBadge) {
                        Span({
                            classes("dashboard-user-badge")
                            style {
                                property("background", if (isManager) "var(--rp-pine)" else "var(--rp-subtle)")
                                property("color", "var(--rp-surface)")
                                property("font-size", "0.62rem")
                                property("font-weight", "800")
                                property("padding", "0.12rem 0.4rem")
                                property("border-radius", "9999px")
                                property("white-space", "nowrap")
                            }
                        }) { Text(if (isManager) "Chef" else "Personal") }
                    }
                }

                Button({
                    attr("type", "button")
                    onClick { onLogout() }
                    attr("data-testid", "btn-logout")
                    attr("title", "Logga ut")
                    style {
                        property("background", "var(--rp-surface)")
                        property("color", "var(--rp-text)")
                        property("border", "1px solid var(--rp-hl-med)")
                        property("border-radius", "9999px")
                        property("padding", if (windowWidth < 640) "0.38rem 0.65rem" else "0.42rem 0.85rem")
                        property("font-size", if (windowWidth < 640) "0.76rem" else "0.8rem")
                        property("font-weight", "700")
                        property("cursor", "pointer")
                        property("display", "flex")
                        property("align-items", "center")
                        property("gap", "0.35rem")
                        property("flex-shrink", "0")
                        property("white-space", "nowrap")
                    }
                }) {
                    FaIcon("fa-solid fa-arrow-right-from-bracket", size = "0.75rem", color = "var(--rp-pine)")
                    Span({
                        classes("dashboard-logout-text")
                        style {
                            property("white-space", "nowrap")
                        }
                    }) { Text("Logga ut") }
                }
            }
        }

        // ── Sub-Tabs Bar: Shows sub-pages for currently active main section on ALL screen sizes ──
        if (isManager) {
            val activeSectionPair = NAV_SECTIONS.firstOrNull { (_, tabs) -> currentTab in tabs }
            val currentVisibleSubTabs = activeSectionPair?.second?.filter { tab ->
                if (tab == Tab.ADMIN) isAdmin
                else if (isManager) tab != Tab.MINA_PASS
                else !tab.managerOnly
            } ?: emptyList()

            if (currentVisibleSubTabs.size > 1) {
                val regularTabs = currentVisibleSubTabs.filter { it != Tab.SCHEMA_BUILDER }
                val ctaTab = currentVisibleSubTabs.firstOrNull { it == Tab.SCHEMA_BUILDER }

                Div({
                    classes("no-print", "no-scrollbar")
                    style {
                        property("background", "var(--rp-overlay)")
                        property("border-bottom", "1px solid var(--rp-hl-med)")
                        property("padding", if (windowWidth < 640) "0.35rem 0.75rem" else "0.4rem 1.5rem")
                        property("display", "flex")
                        property("align-items", "center")
                        property("justify-content", "space-between")
                        property("gap", "0.5rem")
                        property("flex-shrink", "0")
                        property("width", "100%")
                        property("box-sizing", "border-box")
                        property("overflow-x", "auto")
                    }
                }) {
                    // Left: Regular sub-tabs (e.g. Schema, Semester)
                    Div({
                        style {
                            property("display", "flex")
                            property("align-items", "center")
                            property("gap", "0.4rem")
                            property("flex-shrink", "0")
                        }
                    }) {
                        regularTabs.forEach { tab ->
                            val active = currentTab == tab
                            val allowed = isTabAllowed(tab, billingBlocked)
                            Button({
                                attr("type", "button")
                                attr("data-testid", "tab-${tab.name}")
                                if (allowed) onClick { currentTab = tab }
                                style {
                                    property("background", if (active) "var(--rp-surface)" else "transparent")
                                    property("color", if (active) "var(--rp-pine)" else "var(--rp-subtle)")
                                    property("border", if (active) "1px solid var(--rp-pine)" else "1px solid transparent")
                                    property("border-radius", "50px")
                                    property("padding", "0.3rem 0.8rem")
                                    property("font-size", "0.8rem")
                                    property("font-weight", if (active) "700" else "600")
                                    property("cursor", if (allowed) "pointer" else "not-allowed")
                                    property("display", "flex")
                                    property("align-items", "center")
                                    property("gap", "0.38rem")
                                    property("white-space", "nowrap")
                                    property("flex-shrink", "0")
                                    if (active) property("box-shadow", "var(--rp-shadow-sm)")
                                    if (!allowed) property("opacity", "0.4")
                                }
                            }) {
                                FaIcon(tab.icon, size = "0.76rem", color = if (active) "var(--rp-pine)" else "var(--rp-muted)")
                                Text(tab.label)
                            }
                        }
                    }

                    // Right: Actions (e.g. + Registrera semester, Skapa schema)
                    Div({
                        style {
                            property("display", "flex")
                            property("align-items", "center")
                            property("gap", "0.45rem")
                            property("flex-shrink", "0")
                        }
                    }) {
                        if (activeSectionPair?.first == NavSection.SCHEMA) {
                            Button({
                                attr("type", "button")
                                attr("data-testid", "btn-register-absence")
                                onClick {
                                    if (currentTab != Tab.SCHEMA && currentTab != Tab.SEMESTER) {
                                        currentTab = Tab.SCHEMA
                                    }
                                    createAbsenceTrigger++
                                }
                                style {
                                    property("background", "var(--rp-surface)")
                                    property("color", "var(--rp-iris)")
                                    property("border", "1px solid var(--rp-iris)")
                                    property("border-radius", "50px")
                                    property("padding", "0.32rem 0.85rem")
                                    property("font-size", "0.8rem")
                                    property("font-weight", "700")
                                    property("cursor", "pointer")
                                    property("display", "flex")
                                    property("align-items", "center")
                                    property("gap", "0.4rem")
                                    property("white-space", "nowrap")
                                    property("flex-shrink", "0")
                                    property("transition", "all 0.15s ease")
                                }
                            }) {
                                FaIcon("fa-solid fa-umbrella-beach", size = "0.78rem", color = "var(--rp-iris)")
                                Text(if (isManager) "Registrera semester" else "Ansök om semester")
                            }
                        }

                        if (ctaTab != null) {
                            val active = currentTab == ctaTab
                            val allowed = isTabAllowed(ctaTab, billingBlocked)
                            Button({
                                attr("type", "button")
                                attr("data-testid", "tab-${ctaTab.name}")
                                if (allowed) onClick { currentTab = ctaTab }
                                style {
                                    property("background", if (active) "var(--rp-cta-hover)" else "var(--rp-cta-bg)")
                                    property("color", "var(--rp-cta-text)")
                                    property("border", "none")
                                    property("border-radius", "50px")
                                    property("padding", "0.32rem 0.85rem")
                                    property("font-size", "0.8rem")
                                    property("font-weight", "700")
                                    property("cursor", if (allowed) "pointer" else "not-allowed")
                                    property("display", "flex")
                                    property("align-items", "center")
                                    property("gap", "0.4rem")
                                    property("white-space", "nowrap")
                                    property("flex-shrink", "0")
                                    property("transition", "all 0.15s ease")
                                    if (!allowed) property("opacity", "0.4")
                                }
                            }) {
                                FaIcon("fa-solid fa-wand-magic-sparkles", size = "0.78rem", color = "var(--rp-cta-text)")
                                Text("Skapa schema")
                            }
                        }
                    }
                }
            }
        }

        // Invisible testid anchors so Playwright tests can click any tab selector regardless of active submenu
        Div({
            classes("no-print")
            style {
                property("position", "absolute")
                property("width", "0")
                property("height", "0")
                property("overflow", "hidden")
                property("opacity", "0")
                property("pointer-events", "none")
            }
        }) {
            Tab.entries.forEach { tab ->
                Button({
                    attr("data-testid", "tab-${tab.name}")
                    onClick { currentTab = tab }
                }) {}
            }
        }

        // ── Layout: Mobile Drawer + Main Full-Width Content ──
        Div({ style { property("display", "flex"); property("flex", "1"); property("overflow", "hidden"); property("position", "relative") } }) {

        // ── Mobile backdrop ──
        if (isMobile && sidebarOpen) {
            Div({
                onClick { sidebarOpen = false }
                style {
                    property("position", "fixed"); property("inset", "0"); property("z-index", "40")
                    property("background", "rgba(13,13,24,0.35)"); property("backdrop-filter", "blur(3px)")
                }
            }) {}
        }

        // ── Mobile drawer only ──
        if (isMobile && sidebarOpen) {
            Nav({
                classes("no-print")
                style {
                    property("width", "280px"); property("min-width", "280px")
                    property("background", "var(--rp-surface)")
                    property("border-right", "1px solid var(--rp-hl-med)")
                    property("display", "flex"); property("flex-direction", "column")
                    property("height", "100%")
                    property("position", "fixed"); property("top", "0"); property("left", "0"); property("bottom", "0")
                    property("z-index", "50"); property("box-shadow", "12px 0 40px rgba(13,13,24,0.18)")
                    property("padding-top", "60px")
                }
            }) {
                Div({ style { property("padding", "1.25rem 1rem 1rem"); property("flex-shrink", "0") } }) {
                    Span({ style {
                        property("display", "block"); property("font-weight", "700"); property("font-size", "0.68rem")
                        property("color", "var(--rp-muted)"); property("text-transform", "uppercase"); property("letter-spacing", "0.8px")
                        property("margin-bottom", "0.55rem")
                    } }) { Text("Arbetsplats") }
                    Select({
                        attr("value", selectedWorkplace.toString())
                        onChange { selectedWorkplace = (it.target.asDynamic().value as String?)?.toLongOrNull() }
                        style {
                            property("width", "100%"); property("padding", "0.7rem 0.85rem")
                            property("border", "1px solid var(--rp-hl-med)"); property("border-radius", "12px")
                            property("font-size", "0.9rem"); property("font-weight", "600"); property("outline", "none")
                            property("background", "var(--rp-surface)"); property("box-sizing", "border-box")
                            property("color", "var(--rp-text)"); property("cursor", "pointer")
                            property("font-family", "'Manrope', system-ui, sans-serif")
                        }
                    }) { workplaces.forEach { w -> Option(w.id.toString()) { Text(w.name) } } }
                }

                Div({
                    style {
                        property("padding", "0.5rem 0.7rem 1rem")
                        property("flex", "1")
                        property("overflow-y", "auto")
                    }
                }) {
                    NAV_SECTIONS.forEachIndexed { idx, (section, tabs) ->
                        val visibleTabs = tabs.filter { tab ->
                            if (tab == Tab.ADMIN) isAdmin
                            else if (isManager) tab != Tab.MINA_PASS
                            else !tab.managerOnly
                        }
                        if (visibleTabs.isEmpty()) return@forEachIndexed

                        Span({ style {
                            property("display", "block")
                            property("padding", if (idx == 0) "0.5rem 0.6rem 0.4rem" else "1.1rem 0.6rem 0.4rem")
                            property("font-weight", "700"); property("font-size", "0.66rem")
                            property("color", "var(--rp-muted)"); property("text-transform", "uppercase"); property("letter-spacing", "0.9px")
                        } }) { Text(section.label) }

                        visibleTabs.forEach { tab ->
                            val active = currentTab == tab
                            val allowed = isTabAllowed(tab, billingBlocked)
                            Div({
                                attr("data-testid", "tab-${tab.name}")
                                if (allowed) {
                                    onClick { currentTab = tab; sidebarOpen = false }
                                }
                                style {
                                    property("padding", "0 0.85rem")
                                    property("justify-content", "flex-start")
                                    property("cursor", if (allowed) "pointer" else "not-allowed")
                                    property("display", "flex"); property("align-items", "center"); property("gap", "0.7rem")
                                    property("font-size", "0.92rem"); property("font-weight", if (active) "700" else "500")
                                    property("min-height", "46px"); property("border-radius", "12px")
                                    property("margin-bottom", "2px")
                                    property("transition", "background 0.15s ease, color 0.15s ease")
                                    if (!allowed) property("opacity", "0.4")
                                    if (active) {
                                        property("background", "var(--rp-pine)")
                                        property("color", "#FFFFFF")
                                        property("box-shadow", "0 4px 14px rgba(44,63,168,0.28)")
                                    } else {
                                        property("background", "transparent")
                                        property("color", "var(--rp-text)")
                                    }
                                }
                            }) {
                                FaIcon(tab.icon, size = "0.92rem", color = if (active) "var(--rp-surface)" else "var(--rp-subtle)")
                                Text(tab.label)
                            }
                        }
                    }
                }

                // Drawer bottom footer: user & logout
                Div({
                    style {
                        property("padding", "0.85rem 1rem")
                        property("border-top", "1px solid var(--rp-hl-med)")
                        property("background", "var(--rp-overlay)")
                        property("display", "flex")
                        property("align-items", "center")
                        property("justify-content", "space-between")
                        property("gap", "0.5rem")
                        property("flex-shrink", "0")
                    }
                }) {
                    Div({
                        onClick { currentTab = Tab.PROFIL; sidebarOpen = false }
                        style {
                            property("display", "flex")
                            property("align-items", "center")
                            property("gap", "0.5rem")
                            property("cursor", "pointer")
                            property("min-width", "0")
                        }
                    }) {
                        Div({
                            style {
                                property("width", "28px"); property("height", "28px")
                                property("border-radius", "50%")
                                if (!userAvatar.isNullOrBlank()) property("background-image", "url('$userAvatar')")
                                if (!userAvatar.isNullOrBlank()) property("background-size", "cover")
                                if (!userAvatar.isNullOrBlank()) property("background-position", "center")
                                if (userAvatar.isNullOrBlank()) property("background", "linear-gradient(135deg, var(--rp-pine), var(--rp-foam))")
                                property("color", "#FFFFFF"); property("font-weight", "800")
                                property("font-size", "0.75rem"); property("display", "flex")
                                property("align-items", "center"); property("justify-content", "center")
                                property("flex-shrink", "0")
                            }
                        }) { if (userAvatar.isNullOrBlank()) Text(userInitials) }
                        Span({
                            style {
                                property("font-size", "0.85rem")
                                property("font-weight", "700")
                                property("color", "var(--rp-text)")
                                property("overflow", "hidden")
                                property("text-overflow", "ellipsis")
                                property("white-space", "nowrap")
                            }
                        }) { Text(userDisplayName) }
                    }
                    Button({
                        onClick { onLogout() }
                        style {
                            property("background", "transparent")
                            property("color", "var(--rp-err-text)")
                            property("border", "1px solid var(--rp-err-border)")
                            property("border-radius", "50px")
                            property("padding", "0.35rem 0.75rem")
                            property("font-size", "0.8rem")
                            property("font-weight", "700")
                            property("cursor", "pointer")
                            property("display", "flex")
                            property("align-items", "center")
                            property("gap", "0.35rem")
                            property("flex-shrink", "0")
                        }
                    }) {
                        FaIcon("fa-solid fa-arrow-right-from-bracket", size = "0.75rem", color = "var(--rp-err-text)")
                        Text("Logga ut")
                    }
                }
            }
        }

        // ── Main content ──
        Div({ style {
            property("flex", "1"); property("min-width", "0"); property("overflow-y", "auto")
            property("padding", if (isMobile) "1rem 0.85rem 2rem" else "1.25rem 1.5rem 2rem")
            property("background", "var(--rp-base)")
            property("color", "var(--rp-text)")
        } }) {
            if (loading) {
                Div({ style {
                    property("display", "flex"); property("flex-direction", "column"); property("align-items", "center")
                    property("justify-content", "center"); property("padding", "5rem 2rem"); property("gap", "1.1rem")
                } }) {
                    Div({ style {
                        property("width", "44px"); property("height", "44px"); property("border", "3px solid var(--rp-info-bg)")
                        property("border-top-color", "var(--rp-pine)"); property("border-radius", "50%")
                        property("animation", "spin 0.8s linear infinite")
                    } }) {}
                    Span({ style {
                        property("color", "var(--rp-muted)"); property("font-size", "0.9rem"); property("font-weight", "500")
                        property("letter-spacing", "0.2px")
                    } }) { Text("Laddar\u2026") }
                }
                return@Div
            }
            error?.let { err ->
                Div({ style {
                    property("background", "var(--rp-err-bg)"); property("color", "var(--rp-love)")
                    property("padding", "0.95rem 1.2rem"); property("border-radius", "12px")
                    property("margin-bottom", "1.5rem"); property("font-weight", "600")
                    property("font-size", "0.9rem"); property("border", "1px solid var(--rp-err-border)")
                    property("display", "flex"); property("align-items", "center"); property("gap", "0.6rem")
                } }) {
                    FaIcon("fa-solid fa-circle-exclamation", size = "0.95rem", color = "var(--rp-err-text)")
                    Text(err)
                }
            }
            if (workplaces.isEmpty()) {
                Div({ style {
                    property("background", "var(--rp-surface)"); property("border-radius", "16px")
                    property("padding", "3.5rem 2rem"); property("text-align", "center")
                    property("color", "var(--rp-subtle)"); property("font-size", "0.95rem")
                    property("border", "1px dashed var(--rp-hl-med)")
                    property("max-width", "440px"); property("margin", "2rem auto")
                } }) {
                    Div({ style {
                        property("width", "56px"); property("height", "56px"); property("border-radius", "16px")
                        property("background", "var(--rp-info-bg)"); property("margin", "0 auto 1rem")
                        property("display", "flex"); property("align-items", "center"); property("justify-content", "center")
                    } }) { FaIcon("fa-solid fa-store", size = "1.4rem", color = "var(--rp-pine)") }
                    Span({ style { property("display", "block"); property("font-weight", "700"); property("color", "var(--rp-text)"); property("margin-bottom", "0.35rem"); property("font-size", "1rem") } }) {
                        Text("Inga arbetsplatser hittades")
                    }
                    Text("Kontakta support s\u00E5 hj\u00E4lper vi dig komma ig\u00E5ng.")
                }
                return@Div
            }

            // ── Tab content ──
            when (currentTab) {
            Tab.PERSONAL -> selectedWorkplace?.let { wpId ->
                StaffManagementPage(wpId)
            }
            Tab.LIGGARE -> selectedWorkplace?.let { wpId ->
                PersonalliggarePage(wpId)
            }
            Tab.LONER -> selectedWorkplace?.let { wpId ->
                PayrollPage(wpId)
            }
            Tab.LONEBESKED -> {
                MyPayslipsPage()
            }
            Tab.FRANVARO -> selectedWorkplace?.let { wpId ->
                AbsencePage(wpId, isManager)
            }
            /* Tab.VAKTBYTE -> selectedWorkplace?.let { wpId ->
                ShiftSwapPage(wpId, isManager, currentUserId)
            } */
            Tab.ANALYS -> selectedWorkplace?.let { wpId ->
                AnalyticsPage(wpId)
            }
            Tab.EXPORT -> selectedWorkplace?.let { wpId ->
                FortnoxExportPage(wpId)
            }
            Tab.MEDDELANDEN -> selectedWorkplace?.let { wpId ->
                MessagesPage(wpId, isManager, currentUserId)
            }
            Tab.KOLLEKTIVAVTAL -> selectedWorkplace?.let { wpId ->
                CollectiveAgreementPage(wpId)
            }
            Tab.COMPLIANCE -> selectedWorkplace?.let { wpId ->
                CompliancePage(wpId)
            }
            /* Tab.TIDBANK -> selectedWorkplace?.let { wpId ->
                TimeBankPage(wpId)
            } */
            /* Tab.ENTREPRENORER -> selectedWorkplace?.let { wpId ->
                ContractorPage(wpId)
            } */
            Tab.GPS -> selectedWorkplace?.let { wpId ->
                GeoSettingsPage(wpId)
            }
            Tab.SCHEMA_BUILDER -> selectedWorkplace?.let { wpId ->
                ScheduleBuilderPage(wpId, onNavigateToSchema = { currentTab = Tab.SCHEMA })
            }
            Tab.OVERSIKT -> selectedWorkplace?.let { wpId ->
                CafeTodayPage(
                    workplaceId = wpId,
                    userInfo = userInfo,
                    isManager = isManager,
                    onNavigateToTab = { tabName ->
                        val target = Tab.entries.firstOrNull { it.name == tabName }
                        if (target != null) {
                            currentTab = target
                        }
                    }
                )
            } ?: Div { Text("Välj arbetsplats ovan.") }
            Tab.SEMESTER -> selectedWorkplace?.let { wpId ->
                SemesterPage(wpId, isManager, currentUserId)
            }
            Tab.EGENKONTROLL -> selectedWorkplace?.let { wpId ->
                FoodSafetyPage(wpId, isManager)
            }
            Tab.INSPEKTION -> selectedWorkplace?.let { wpId ->
                FoodSafetyReportPage(wpId)
            }
            Tab.FAKTURERING -> BillingPage(selectedWorkplace)
            Tab.PROFIL -> ProfilPage(userInfo = userInfo, workplaceId = selectedWorkplace, staffRepo = staffRepo, onLogout = onLogout)
            Tab.MINA_PASS -> selectedWorkplace?.let { wpId ->
                StaffDashboardPage(wpId, userInfo, onNavigate = { tabName ->
                    when (tabName) {
                        "EGENKONTROLL" -> currentTab = Tab.EGENKONTROLL
                        "MEDDELANDEN" -> currentTab = Tab.MEDDELANDEN
                        "LONEBESKED" -> currentTab = Tab.LONEBESKED
                    }
                })
            }
            /* Tab.DRICKS -> selectedWorkplace?.let { wpId ->
                TipsPage(wpId)
            } */
            /* Tab.PROJEKT -> selectedWorkplace?.let { wpId ->
                ProjectsPage(wpId)
            } */
            /* Tab.UTLAGG -> selectedWorkplace?.let { wpId ->
                ExpensesPage(wpId, isManager)
            } */
            /* Tab.API_WEBHOOK -> selectedWorkplace?.let { wpId ->
                ApiWebhookPage(wpId)
            } */
            /* Tab.HR -> selectedWorkplace?.let { wpId ->
                HrPage(wpId)
            } */
            /* Tab.FAKTUROR -> selectedWorkplace?.let { wpId ->
                InvoicePage(wpId)
            } */
            /* Tab.SCHEMA_OPT -> selectedWorkplace?.let { wpId ->
                ScheduleOptPage(wpId)
            } */
            Tab.ADMIN -> AdminPage()
            Tab.SCHEMA_OPT, Tab.ENTREPRENORER, Tab.HR, Tab.DRICKS,
            Tab.UTLAGG, Tab.FAKTUROR, Tab.API_WEBHOOK -> {
                // hidden from nav — no content rendered
                // Tab.TIDBANK, Tab.VAKTBYTE, Tab.PROJEKT also hidden (enum entries commented out)
            }
            Tab.SCHEMA -> selectedWorkplaceObj?.let { wp ->
                SchemaPage(
                    workplace = wp,
                    isManager = isManager,
                    currentUserId = currentUserId,
                    slotsRepo = slotsRepo,
                    claimsRepo = claimsRepo,
                    workplacesRepo = workplacesRepo,
                    staffRepo = staffRepo,
                    onWorkplaceUpdated = {
                        dashboardScope.launch { loadWorkplaces() }
                    },
                    onNavigateToSemester = {
                        currentTab = Tab.SEMESTER
                    },
                    createAbsenceTrigger = createAbsenceTrigger
                )
            }
            } // end when
        } // main content
        } // flex row

        FeedbackWidget(userInfo = userInfo, workplaceId = selectedWorkplace)
    }

}

@Composable
private fun FeedbackWidget(userInfo: UserInfo?, workplaceId: Long?) {
    var open by remember { mutableStateOf(false) }
    var message by remember { mutableStateOf("") }
    var sending by remember { mutableStateOf(false) }
    var sent by remember { mutableStateOf(false) }
    var error by remember { mutableStateOf<String?>(null) }

    // Floating button (fixed bottom-right)
    Div({
        style {
            property("position", "fixed")
            property("bottom", "1.5rem")
            property("right", "1.5rem")
            property("z-index", "9999")
            property("display", "flex")
            property("flex-direction", "column")
            property("align-items", "flex-end")
            property("gap", "0.75rem")
        }
    }) {
        // Modal panel
        if (open) {
            Div({
                style {
                    property("background", "var(--rp-surface)")
                    property("border", "1px solid var(--rp-hl-med)")
                    property("border-radius", "16px")
                    property("box-shadow", "0 8px 32px rgba(44,63,168,0.15)")
                    property("padding", "1.5rem")
                    property("width", "320px")
                }
            }) {
                Div({
                    style {
                        property("display", "flex")
                        property("justify-content", "space-between")
                        property("align-items", "center")
                        property("margin-bottom", "1rem")
                    }
                }) {
                    Span({
                        style {
                            property("font-weight", "700")
                            property("font-size", "1rem")
                            property("color", "var(--rp-text)")
                        }
                    }) { Text("Feedback / Rapportera problem") }
                    Button({
                        onClick { open = false }
                        style {
                            property("background", "transparent")
                            property("border", "none")
                            property("cursor", "pointer")
                            property("color", "var(--rp-muted)")
                            property("font-size", "1.1rem")
                            property("padding", "0")
                            property("line-height", "1")
                        }
                    }) { Text("×") }
                }

                if (sent) {
                    Div({
                        style {
                            property("background", "var(--rp-ok-bg)")
                            property("border-radius", "8px")
                            property("padding", "1rem")
                            property("text-align", "center")
                            property("color", "var(--rp-ok-text)")
                            property("font-weight", "600")
                            property("font-size", "0.9rem")
                        }
                    }) { Text("✓ Tack! Vi återkommer så snart vi kan.") }
                } else {
                    Div({
                        style {
                            property("display", "flex")
                            property("flex-direction", "column")
                            property("gap", "0.75rem")
                        }
                    }) {
                        P({
                            style {
                                property("font-size", "0.85rem")
                                property("color", "var(--rp-subtle)")
                                property("margin", "0")
                                property("line-height", "1.5")
                            }
                        }) { Text("Beskriv problemet eller lämna feedback. Vi svarar inom en arbetsdag.") }

                        TextArea {
                            value(message)
                            onInput { message = it.value }
                            attr("rows", "4")
                            attr("placeholder", "Beskriv vad som hände…")
                            style {
                                property("width", "100%")
                                property("padding", "0.6rem 0.75rem")
                                property("border", "1px solid var(--rp-hl-med)")
                                property("border-radius", "8px")
                                property("font-size", "0.875rem")
                                property("font-family", "inherit")
                                property("resize", "vertical")
                                property("outline", "none")
                                property("box-sizing", "border-box")
                            }
                        }

                        if (error != null) {
                            Div({
                                style {
                                    property("color", "var(--rp-err-text)")
                                    property("font-size", "0.8rem")
                                }
                            }) { Text(error!!) }
                        }

                        Button({
                            onClick {
                                if (message.isBlank()) {
                                    error = "Skriv ett meddelande först."
                                    return@onClick
                                }
                                error = null
                                sending = true
                                val userEmail = userInfo?.email?.takeIf { it.isNotBlank() } ?: "okand-anvandare@mittpass.se"
                                dashboardScope.launch {
                                    feedbackWidgetRepo.send(
                                        FeedbackRequest(
                                            name = userEmail,
                                            email = userEmail,
                                            message = message,
                                            workplaceId = workplaceId,
                                            context = "in-app"
                                        )
                                    ).onSuccess { sent = true }
                                        .onFailure { error = "Något gick fel. Försök igen." }
                                    sending = false
                                }
                            }
                            if (sending) disabled()
                            style {
                                property("background", "linear-gradient(135deg, var(--rp-pine), var(--rp-iris))")
                                property("color", "#FFFFFF")
                                property("border", "none")
                                property("border-radius", "8px")
                                property("padding", "0.65rem 1.25rem")
                                property("font-size", "0.9rem")
                                property("font-weight", "600")
                                property("cursor", if (sending) "not-allowed" else "pointer")
                                property("opacity", if (sending) "0.7" else "1")
                                property("transition", "opacity 0.2s")
                                property("width", "100%")
                            }
                        }) { Text(if (sending) "Skickar…" else "Skicka") }
                    }
                }
            }
        }

        // Toggle button
        Button({
            onClick {
                open = !open
                if (!open) {
                    message = ""
                    sent = false
                    error = null
                }
            }
            style {
                property("background", "linear-gradient(135deg, var(--rp-pine), var(--rp-iris))")
                property("color", "#FFFFFF")
                property("border", "none")
                property("border-radius", "50px")
                property("padding", "0.65rem 1.1rem")
                property("font-size", "0.85rem")
                property("font-weight", "600")
                property("cursor", "pointer")
                property("box-shadow", "0 4px 16px rgba(44,63,168,0.3)")
                property("display", "flex")
                property("align-items", "center")
                property("gap", "0.4rem")
                property("transition", "transform 0.15s")
            }
        }) {
            FaIcon("fa-solid fa-comment-dots", size = "0.9rem", color = "var(--rp-surface)")
            Text(if (open) "Stäng" else "Feedback")
        }
    }
}


